import React from 'react';
import { UTLabel } from '@widergy/energy-ui';
import { string, func } from 'prop-types';

import { message } from 'utils/stringUtils';
import { officeSlotType, referenceType } from 'types/turnsTypes';

import UserInformationForm from './components/UserInformationForm';
import styles from './styles.module.scss';

const UserInformation = ({
  phone,
  email,
  clientNumber,
  refUserInformation,
  currentOfficeSlot,
  handleSubmit
}) => (
  <div className={`${!currentOfficeSlot && styles.hidden}`}>
    <span className={styles.anchor} ref={refUserInformation} />
    <UTLabel semibold large className={styles.title}>
      {message('Turns:contactInformation')}
    </UTLabel>
    <UserInformationForm
      onSubmit={handleSubmit}
      initialValues={{ fieldEmail: email, fieldPhone: phone, fieldClientNumber: clientNumber }}
    />
  </div>
);

UserInformation.propTypes = {
  phone: string,
  email: string,
  clientNumber: string,
  handleSubmit: func,
  currentOfficeSlot: officeSlotType,
  refUserInformation: referenceType
};

export default UserInformation;
